import React, { useMemo } from 'react'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import RecordHistory from '../RecordHistory/RecordHistory'
import { useSelector, shallowEqual } from 'react-redux'
import '../RecordHistory/RecordHistory.scss'

const SearchRecordHistory = ({ historyModalOpen, setHistoryModalOpen, searchFields }) => {
  const { recordDetails } = useSelector((state) => state.record, shallowEqual)

  const amendments = useMemo(() => {
    switch (searchFields.Name) {
      case 'AthleteAgentSearch':
        return recordDetails.AMENDMENT_LIST || []
      default:
        return []
    }
  }, [recordDetails, searchFields])

  const history = useMemo(() => {
    switch (searchFields.Name) {
      case 'AthleteAgentSearch':
        return recordDetails.HISTORY_LIST || []
      default:
        return []
    }
  }, [recordDetails, searchFields])

  const template = useMemo(() => {
    switch (searchFields.Name) {
      case 'AthleteAgentSearch':
        return recordDetails.TEMPLATE || []
      default:
        return []
    }
  }, [recordDetails, searchFields])

  return (
    <Portal isOpened={historyModalOpen}>
      <Modal
        modalSize="fullscreen"
        closeModal={() => setHistoryModalOpen(false)}
        title="History"
        closeButton
        autoHeight
        modalBodyClassName="history-modal"
      >
        <div style={{ maxHeight: '80vh', overflowY: 'scroll', marginBottom: '10px' }}>
          <RecordHistory
            history={{
              amendments: amendments,
              history: history,
              template: template,
            }}
          />
        </div>
      </Modal>
    </Portal>
  )
}

export default SearchRecordHistory
